export const INITIAL_VARIANT = 'gold';
export const videos = [...document.querySelectorAll('.section-intro__video')];
const images = [
  ...document.querySelectorAll('.section-feature__media-image'),
  ...document.querySelectorAll('.feature-detail__media-image'),
];
const videoWidths = [640, 1280, 1920];

export function initVariants(target) {
  const inputs = target.querySelectorAll('[name="variant"]');
  inputs.forEach(input => input.addEventListener('change', e => changeVariant(e.target.value, true)));

  setVideoWidth();
  changeVariant(INITIAL_VARIANT);
}

function setVideoWidth() {
  const videoWidth = videoWidths.find(width => width >= realScreenWidth()) || videoWidths[videoWidths.length - 1];
  videos.forEach(video => {
    if (video.dataset.variant === INITIAL_VARIANT) {
      const backgroundImage = window.getComputedStyle(video).getPropertyValue('background-image');
      //video.poster = backgroundImage.slice(4, -1).replace(/"/g, '');
    }
    video.src = `/video/${video.dataset.variant}-${videoWidth}.mp4`;
  });
}

function realScreenWidth() {
  return window.innerWidth * window.devicePixelRatio;
}

function getCurrentVariant() {
  return document.body.dataset.variant || INITIAL_VARIANT;
}

function changeVariant(variant, restartVideo = false) {
  const prevVariant = getCurrentVariant();
  const activeClass = 'active';

  // Video
  const prevVideo = videos.find(video => video.dataset.variant === prevVariant);
  const video = videos.find(video => video.dataset.variant === variant);
  prevVideo.classList.remove(activeClass);
  video.classList.add(activeClass);
  if (restartVideo && video.paused) {
    playVideos(videos);
  }

  // Images
  images.forEach(image => {
    // <picture> element
    const sources = image.closest('picture').querySelectorAll('source');
    sources.forEach(source => source.srcset = source.srcset.replaceAll(prevVariant, variant));
    // <img> element
    // image.srcset = image.srcset.replaceAll(prevVariant, variant);
  });

  document.body.dataset.variant = variant;
}

export function playVideos(videos) {
  videos.forEach(video => video.play());
}
